/*global resortModule*/
resortModule.run(['$rootScope', '$location', function ($rootScope, $location) {
    $rootScope.ifPaymentForm = function () {
        if ($location.path().indexOf("payment") > -1) {
            return true;
        }
    };
}]);
